import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import { setAutoRefresh, setValidations, setSelectedItem, setSearchTerm } from '../../redux/dataSlice';
import { initializeAuth, getValidationsByFilter } from '../../services/apiService';
import { useMsal } from "@azure/msal-react";
import DropDownSearchType from '../layout/DropDownSearchType';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const SearchData = () => {
  const dispatch = useDispatch();
  const { instance, accounts } = useMsal();
  const [searchText, setSearchText] = useState('');
  const [startDate, setStartDate] = useState((new Date()).setMonth((new Date()).getMonth() - 1));
  const [endDate, setEndDate] = useState(new Date());
  const [searchText2, setSearchText2] = useState('');
  const [loading, setLoading] = useState(false);
  const { autoRefresh, dbSrc, searchType, itemTab } = useSelector(state => state.data);
  const resultsBlue = itemTab === 'search' ? 'headerBlue borderBlue' : '';
  const [isDateSearch, setIsDateSearch] = useState(false);

  useEffect(() => {
    const resetSearch = async () => {
        dispatch(setSelectedItem({}));     
        setSearchText('');
    };
    resetSearch();
  }, [dbSrc]);

  useEffect(() => {
    if (startDate) {
        const dateString = new Date(startDate).toISOString().split('T')[0];
        setSearchText(dateString);
    }
  }, [startDate]);

  useEffect(() => {
    if (endDate) {
        const dateString = new Date(endDate).toISOString().split('T')[0];
        setSearchText2(dateString);
    }
  }, [endDate]);
  
  useEffect(() => {
    if (searchType === 'Date') {
        setIsDateSearch(true);
        let startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 1);
        const dateString = startDate.toISOString().split('T')[0];
        setSearchText(dateString);
        setSearchText2(new Date().toISOString().split('T')[0]);
    }
    else {
        setIsDateSearch(false);
        setSearchText('');
        setSearchText2('');
    }
  }, [searchType]);

  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  }

  const resetForm = () => {
    setSearchText('');
    setSearchText2('');
    dispatch(setSelectedItem({}));
  };

  const handleSearch = async () => {
    if (searchText.trim()) {
      setLoading(true);
      dispatch(setValidations([]));
      dispatch(setSelectedItem({}));

      await initializeAuth(instance, accounts);
      try {
        const response = await getValidationsByFilter(searchType, searchText.trim(), searchText2.trim(), 1, 12);
        console.log("Fetched Tree:", response);
        dispatch(setValidations(response));
        dispatch(setSearchTerm(searchText.trim()));
      } catch (error) {
        console.error("Failed to fetch tree:", error);
      } finally {
        setLoading(false);
      }
    }
  };

return (
    <div className="w-full">
      <div className="flex w-full space-x-2 mb-2">
          <DropDownSearchType />
          { isDateSearch &&
            <div className="flex w-full space-x-2">
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                className="flex-1 border p-2 rounded"
                placeholderText="Select start date..."
                dateFormat="MM/dd/yyyy"
                d
              />
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                className="flex-1 border p-2 rounded"
                placeholderText="Select end date..."
                dateFormat="MM/dd/yyyy"
              />
            </div>
          }
          { !isDateSearch && 
            <input
                type="text"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onKeyUp={handleKeyUp}
                className="flex-1 border p-2 rounded"
                placeholder="Enter item text..."
            />
          }
          <button
            onClick={handleSearch}
            className="bg-blue-500 text-white px-4 rounded hover:bg-blue-600"
            disabled={loading}
          >
            {loading ? "Searching..." : "Search"}
          </button>
          <button className="bg-blue-500 text-white px-4 rounded hover:bg-blue-600" onClick={resetForm}>
            <FontAwesomeIcon icon={faRefresh} />
          </button>
      </div>
      <div className='flex items-center justify-between'>
        <button className={`text-left  ${resultsBlue}`}>Latest Validations</button>
        <div>
          <input type='checkbox' id="autoRefresh" checked={autoRefresh} onChange={() => dispatch(setAutoRefresh(!autoRefresh))} /> <label htmlFor="autoRefresh">Auto Refresh</label>
        </div>
      </div>
    </div>
  );
};

export default SearchData;
